import React from 'react'
import { Grid } from '@material-ui/core'
import GivingSummary from 'components/MyGivingPage/GivingSummary'
import Roundups from 'components/MyGivingPage/Roundups'
import Tithes from 'components/MyGivingPage/Tithes'

export default function MyGivingPage() {
  return(
    <Grid container spacing={1}>
      <Grid container item xs={12} justifyContent='center'>
        <Grid xs={12} sm={10} md={8} lg={6} item>
          <GivingSummary />
        </Grid>
      </Grid>
      <Grid xs={12} sm={6} item>
        <Tithes />
      </Grid>
      <Grid xs={12} sm={6} item>
        <Roundups />
      </Grid>
    </Grid>
  )
}
